import React from 'react';
import PropTypes from 'prop-types';

class TableItemProgress extends React.PureComponent {
    render() {
        const { value } = this.props;
        if (typeof (value) === 'number') {
            const opacity = value * 0.01;
            return (
                <div className="ori-flex-column ori-flex-jc ori-flex-ac">
                    <p className="">{value}%</p>
                    <div className="ori-t-pad-5 ori-border-light ori-border-radius-4 ori-width-70 ori-bg-primary" style={{ opacity: opacity <= 0.15 ? 0.15 : opacity }} />
                </div>
            );
        } else return null;
    }
}

TableItemProgress.propTypes = {
    value: PropTypes.number,
};

export default TableItemProgress;



// WEBPACK FOOTER //
// ./src/components/tableitemprogress/index.js